export default __webpack_public_path__ + "telephone-handle-silhouette.png";